<div class="head-offer">
  <button (click)="backOffers($event)"><i class="fa fa-angle-left"></i>
    <p>Regresar</p>
  </button>
  @if (getConfigLabel().showLabel) {
  <div class="icon-pay">
    <div class="box-sponsor" [ngClass]="getConfigLabel().color">
      <img [src]="getConfigLabel().img" title="{{offerUnique.textLabel.slice(0,20)}}"
        alt="{{offerUnique.textLabel.slice(0,20)}}" />
      <p>{{offerUnique.textLabel.slice(0,20)}}</p>
    </div>
  </div>
  }
</div>
@if (offerUnique != undefined) {
<div class="body-offer">
  <div class="content-offer">
    <div class="left-offer">
      <div>
        @if (!offerUnique.detail.companyLogoFlag) {
        <img src="{{offerUnique.company.entityimg}}" alt="{{offerUnique.company.name }}"
          title="{{offerUnique.card.productName}}" />
        }
        @if (offerUnique.detail.companyLogoFlag) {
        <img src="{{offerUnique.detail.offerLogoURL}}" alt="{{offerUnique.company.name }}"
          title="{{offerUnique.card.productName}}" [ngClass]="{'tc':cardForTC}" />
        }
      </div>
      @if (selectButton() == 1) {
      <button class="btn-cta" (click)="applyOffer($event)">Aplicar ahora<i class="fa fa-angle-right"></i></button>
      }
      @if (selectButton() == 2 && !btn_retomar_aplicacion) {
      <button class="btn-cta blue" (click)="redirect($event)">Retomar aplicación<i
          class="fa fa-angle-right"></i></button>
      }
      @if (selectButton() == 2 && btn_retomar_aplicacion) {
      <button class="btn-cta blue spinner-btn">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      </button>
      }
    </div>
    <div class="right-offer">
      <p class="text-basic big">{{offerUnique.detail.title}}</p>
      <div class="main-info-offer" [ngClass]="{'three-desc': threeLabels}">
        <div>
          <p class="text-basic">Recibes:</p>
          <p class="text-blue">{{offerUnique.card.offerValue}}</p>
        </div>
        <div>
          <p class="text-basic">{{offerUnique.card.offerAproxValueTitle}}</p>
          <p class="text-blue">{{offerUnique.card.offerAproxValue}}</p>
        </div>
        @if (threeLabels) {
        <div>
          <p class="text-basic">{{offerUnique.card.offerDetail1}}</p>
          <p class="text-blue">{{offerUnique.card.offerDetail1value}}</p>
        </div>
        }
      </div>
      @if (offerUnique.detail.additionalBenefits) {
      <div class="add-benefit">
        <img title="crown" class="crown" alt="corona-beneficio" src="assets/icons/Icono_corona_adicional.svg" />
        <div class="box-benefit">
          <p class="descBenefit">{{offerUnique.detail.textAdditionalBenefits}}</p>
        </div>
      </div>
      }
    </div>
  </div>
  <div class="aditional-offer">
    <div class="content-aditional">
      @if (offerUnique.detail.benefits) {
      <div class="box-aditional">
        <p class="title">{{offerUnique.detail.titleBenefits}}:</p>
        <hr />
        <div class="list">
          @for (benefit of offerUnique.detail.benefits; track benefit) {
          <div class="bullet">
            <i class="fa fa-check" aria-hidden="true"></i>
            <p>{{benefit}}</p>
          </div>
          }
        </div>
      </div>
      }
      @if (offerUnique.detail.property) {
      <div class="box-aditional">
        <p class="title">Características de la oferta:</p>
        <hr />
        <div class="list">
          @for (property of offerUnique.detail.property; track property) {
          <div class="bullet">
            <i class="fa fa-check" aria-hidden="true"></i>
            <p>{{property.value}}</p>
          </div>
          }
        </div>
      </div>
      }
      <div class="box-aditional">
        <p class="title">Requisitos de la oferta:</p>
        <hr />
        <div class="list">
          @for (requirements of offerUnique.detail.requirements; track requirements) {
          <div class="bullet">
            <i class="fa fa-check" aria-hidden="true"></i>
            <p>{{requirements}}</p>
          </div>
          }
          <div class="bullet">
            <i class="fa fa-check" aria-hidden="true"></i>
            <p>Puntaje de Datacrédito necesario: <b [ngClass]="[colorScore]">{{textScore}}</b></p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="steps">
    <div class="content-steps">
      <div class="hash">
        <p>#ATuMedida</p>
        <i class="fa fa-sort-down" aria-hidden="true"></i>
      </div>
      <h3>LO QUE DEBES SABER:</h3>
      <div class="box-steps">
        <div>
          <img src="assets/icons/paso_1.png" title="Paso 1" alt="Paso 1" />
          <p>Buscacrédito hace un <b>pre-filtro</b> de tu perfil crediticio, sin embargo, la <b>aprobación
              final</b> dependerá del <b>Aliado</b>.</p>
        </div>
        <div>
          <img src="assets/icons/paso_2.png" title="Paso 2" alt="Paso 2" />
          <p>El proceso de aplicación se termina en el <b>sitio web del aliado</b>, nosotros te
            redireccionaremos allí.</p>
        </div>
        <div>
          <img src="assets/icons/paso_3.png" title="Paso 3" alt="Paso 3" />
          <p><b>Los tiempos</b> de respuesta varían de acuerdo con <b>las políticas</b> de cada entidad.</p>
        </div>
      </div>
    </div>
  </div>
  <div class="sub-footer">
    <div class="content-sub-footer">
      <p>Buscacrédito y Experian no son entidades financieras, somos una plataforma en línea que facilita el
        acceso
        de clientes a productos y servicios ofrecidos por instituciones financieras asociadas y acreditadas en
        la
        plataforma. Para mayor información sobre tasas, comisiones, gastos y demás conceptos aplicables, puede
        recurrir al tarifario de la entidad financiera ubicado en sus oficinas y/o en su página web.</p>
      <p>Experian informa: Buscacrédito es una plataforma 100% gratuita para consumidores Al aplicar a la oferta,
        la
        solicitud del crédito del consumidor será pre aprobada y la finalización de la aplicación al crédito se
        realizará con la entidad financiera.</p>
    </div>
  </div>
</div>
}